import { useEffect, useState } from 'react';

import { UserStats } from '../types/networking';
import { apiMain } from 'services/apiService';

export function useUserStats(userId: string) {
  const [stats, setStats] = useState<UserStats | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  console.log('[useUserStats] userId', userId);

  useEffect(() => {
    setLoading(true);
    setError(null);

    apiMain
      .get<UserStats>(`/networking/v1/stats/user/${userId}`)
      .then(res => setStats(res.data))
      .catch(err => {
        setError(err.message || 'Erro ao buscar stats');
        setStats(null);
      })
      .finally(() => setLoading(false));
  }, [userId]);

  return { stats, loading, error, setLoading, setStats };
}
